import { render, staticRenderFns } from "./ModalConfirmDeletePrompt.vue?vue&type=template&id=a2388f02&scoped=true"
import script from "./ModalConfirmDeletePrompt.vue?vue&type=script&lang=js"
export * from "./ModalConfirmDeletePrompt.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmDeletePrompt.vue?vue&type=style&index=0&id=a2388f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2388f02",
  null
  
)

export default component.exports